import React from 'react';

import cx from 'classnames';

import s from './Spinner.module.css';

type TProps = {
  loading?: boolean;
  className?: string;
  size?: 'big';
};

function Spinner({ loading, className, size }: TProps) {
  if (loading) {
    return (
      <div
        data-testid="spinner"
        className={cx(
          className,
          s.loadingSpinner,
          size === 'big' ? s.bigSpinner : '',
        )}
      />
    );
  }
  return <span style={{ display: 'none', pointerEvents: 'none' }} />;
}

export default Spinner;
